/***
 * Created on 2025/2/4
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import {useTranslation} from "react-i18next";
import ifttt_logo from "../../static/img/utils/logo-ifttt-wordmark-black.svg";
import {useQuery} from "@tanstack/react-query";
import {apiGet} from "../../service/api";
import IftttEmptyDevice from "./ifttt-empty-device";
import IftttDeviceList from "./ifttt-device-list";
import IftttDeviceLogin from "./ifttt-device-login";

function IftttApprove(props) {
    const { t } = useTranslation();

    const {data, error} = useQuery({
        queryKey: ['dauth_authorization_status'],
        queryFn: async () => await apiGet('/ajax/dauth/authorization/status'),
    });

    if (error) {
        console.log(error.cause.code);
    }

    const onApproveClicked = (approved) => {
        window.location.href = `/dauth/authorization/approve/${approved}`;
    }

    return (
        <section className="common-page-wrapper common-page-wrapper--ifttt">
            {data && console.log(data)}
            <div className="common-page-header">
                <div className="ifttt-logo"><img src={ifttt_logo} alt=""/></div>
            </div>
            <div className="common-page-body">
                <div className="ifttt--desc">
                    <div className="ifttt--desc__subtitle">{t('@{app_name} would like to access your QNAP Devices and get the following info:@', {
                        app_name: 'IFTTT',
                        interpolation: {
                            prefix: '{',
                            suffix: '}',
                            escapeValue: false
                        }
                    })}</div>
                    <ul className="list-style-type-disc ml-16">
                        {
                            data && data.scopeset.map((scope, index) => <li className="pl-4 mb-10" key={scope}>{t(`@${scope}@`)}</li>)
                        }
                    </ul>
                    {/*<div className="mt-16"><a href="#">Learn more</a></div>*/}
                </div>
                <div className="ifttt--divide"></div>

                {!data && data?.devices?.length <= 0 && <IftttEmptyDevice/>}

                {data && data?.devices?.length > 0 && <IftttDeviceList devices={data.devices}/>}

            </div>
            {data && data?.devices?.length > 0 &&
                <div className="common-page-footer">
                    <div className="q-btn-group btn-align-right">
                        <button className="q-btn q-btn--primary btn-medium btn-rounded-normal" onClick={e=>onApproveClicked('y')}>{t('@Okay@')}</button>
                        <button className="q-btn q-btn--default btn-medium btn-rounded-normal" onClick={e=>onApproveClicked('n')}>{t('@Cancel@')}</button>
                    </div>
                </div>
            }
        </section>
    );
}

export default IftttApprove;